import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/botompanel.css";
import { Link } from "react-router-dom";
import { getMenuService } from "../header/service/MenuService";

function BottomPanel({ wishlistCount = 0, cartCount = 0 }) {

  const [activeTab, setActiveTab] = useState("home");
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedSub, setExpandedSub] = useState(null);
  const [categories, setCategories] = useState([]);
  const accountRef = useRef(null);

  // API MEGA MENU DATA

  useEffect(() => {
    const loadMenu = async () => {
      const res = await getMenuService();
      setCategories(res);
    };
    loadMenu();
  }, []);

  // ACCOUNT OUTSIDE CLICK
  useEffect(() => {
    const handleClickOutside = (event)=>{
      if(
        accountRef.current &&
        !accountRef.current.contains(event.target)
      ){
        setAccountMenuOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return ()=>{
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };

  }, []);

    // BOTTOM PANEL TAB HANDLER

  const handleTabClick = (key) => {
    if (key === "home") {
      setMenuOpen(true);
      return;
    }
    if (key === "account") {
      setAccountMenuOpen((prev) => !prev);
    }
    setActiveTab(key);
  };

  const toggleCategory=(slug)=>{
    setExpandedCategory(
      prev=>prev===slug ? null : slug
    );
    setExpandedSub(null);
  };



  const toggleSub=(slug)=>{
    setExpandedSub(
      prev=>prev===slug ? null : slug
    );
  };


  const navItems=[
    {
      key:"home",
      label:"Home",
      icon:"bi-house",
      fillIcon:"bi-house-fill"
    },

    {
      key:"category",
      label:"Category",
      icon:"bi-grid",
      fillIcon:"bi-grid-fill"
    },

    {
      key:"Wishlist",
      label:"Wishlist",
      icon:"bi-heart",
      fillIcon:"bi-heart-fill",
      count:wishlistCount,
      path:"/wishlist"
    },

    {
      key:"Cart",
      label:"Cart",
      icon:"bi-cart",
      fillIcon:"bi-cart-fill",
      count:cartCount,
      path:"/checkout/cart"
    },

    {
      key:"account",
      label:"My Account",
      icon:"bi-person",
      fillIcon:"bi-person-fill"
    }

  ];

return (

<>
{/* MOBILE MENU */}

<div
className={`fixed top-0 left-0 h-full w-64 bg-white shadow-2xl z-[999]
transition-transform duration-300
${menuOpen ? "translate-x-0":"-translate-x-full"}`}
>
<div className="flex justify-between p-3 border-b">
<h2> Menu </h2>

<button onClick={()=>setMenuOpen(false)}>
<i className="bi bi-x-lg"></i>
</button>
</div>

<ul className="p-4"
style={{
overflowY:"auto",
height:"530px"
}}
>
{
categories.map((cat)=>(

<li
key={cat.category_slug}
className="border-b pb-2"
>
<div className="flex justify-between items-center py-2 cursor-pointer"
onClick={()=>toggleCategory(cat.category_slug)}
>
<span>
{cat.category_name}
</span>

<i className={`bi ${
expandedCategory===cat.category_slug
?
"bi-chevron-up"
:
"bi-chevron-down"
}`}
></i>
</div>

{
expandedCategory===cat.category_slug &&
<ul className="pl-4">
{
cat.subcategories
?.filter(
sub=>sub.subcategory_name
)
.map(sub=>(

<li key={sub.subcategory_slug} >

<div className="flex justify-between py-2 cursor-pointer"
onClick={(e)=>{
e.stopPropagation();
toggleSub(
sub.subcategory_slug
);
}}
>
<span> {sub.subcategory_name} </span>
{
sub.qualities?.length>0 &&
<i className={`bi ${
expandedSub===sub.subcategory_slug
?
"bi-chevron-up"
:
"bi-chevron-right"
}`}
></i>
}
</div>

{
expandedSub===sub.subcategory_slug &&


<ul className="pl-4">
{
sub.qualities?.map(
quality=>(

<li key={quality.quality_action_link} className="py-1"
>
<Link to={`/products/${quality.quality_action_link}`} >
{quality.quality_name}
</Link>

</li>
))
}
</ul>
}

</li>

))

}
</ul>
}

</li>
))
}
</ul>

</div>

{
menuOpen &&
<div
className="fixed inset-0 bg-black bg-opacity-40 z-[998]"
onClick={()=>setMenuOpen(false)}
></div>
}

{/* BOTTOM BAR */}
   <div className="bottom-panel fixed bottom-0 w-full bg-white shadow-lg z-50">
        <ul className="flex justify-around items-center relative">
          {navItems.map((item) => (
            <li
              key={item.key}
              className={`bottom-nav-item text-center relative ${
                activeTab === item.key ? "text-black-600" : "text-gray-500"
              }`}
              onClick={() => handleTabClick(item.key)}
              ref={item.key === "account" ? accountRef : null}
              >
              <Link to={item.path} className="flex flex-col items-center relative">
                <div className="icon mb-1 relative">
                  <i
                    className={`bi ${
                      activeTab === item.key ? item.fillIcon : item.icon
                    } text-lg`}
                  ></i>
                  {"count" in item && (
                    <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full px-1.5 py-0.5">
                      {item.count}
                    </span>
                  )}
                </div>
                    <span className="text-xs font-medium">{item.label}</span>
              </Link>

              {/*------------ ACCOUNT DROPDOWN --------------*/}
              
              {item.key === "account" && accountMenuOpen && (
                <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-white border rounded-lg shadow-lg w-36 text-sm z-10">
                  <ul className="flex flex-col py-1">
                    <li>
                      <Link
                        to="/login"
                        className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100"
                         >
                        <i className="bi bi-box-arrow-in-right"></i>
                        <span> Sign In </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/profile"
                        className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100"
                         >
                           <i className="bi bi-people"></i>
                           <span> My Profile </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}

            </li>
          ))}
        </ul>
      </div>

</>
);

}


export default BottomPanel;